export const DateValidator = {
    MinDate: "minimumDateValidator",
    MaxDate: "maximumDateValidator",
} as const;

type DateType = (typeof DateValidator)[keyof typeof DateValidator];

export const TodayValidator = {
    MinToday: "minimumDateTodayValidator",
    MaxToday: "maximumDateTodayValidator",
} as const;
type TodayType = (typeof TodayValidator)[keyof typeof TodayValidator];
type DateObj = {
    validatorType: DateType;
    date: string;
};

export type IDateValidator = [DateObj | TodayType, DateObj | TodayType];

export interface ParsedDateValidators {
    minDate: Date | null;
    maxDate: Date | null;
}

export function parseDateValidators(validators?: IDateValidator): ParsedDateValidators {
    let minDate: Date | null = null;
    let maxDate: Date | null = null;

    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    (validators ?? []).forEach((validator) => {
        if (typeof validator === "string") {
            if (validator === TodayValidator.MinToday) {
                minDate = new Date(today);
            }
            if (validator === TodayValidator.MaxToday) {
                maxDate = new Date(today);
            }
        }

        if (typeof validator === "object") {
            if (validator.validatorType === DateValidator.MinDate) {
                const date = new Date(validator.date);
                if (!Number.isNaN(date.getTime())) {
                    minDate = date;
                }
            }
            if (validator.validatorType === DateValidator.MaxDate) {
                const date = new Date(validator.date);
                if (!Number.isNaN(date.getTime())) {
                    maxDate = date;
                }
            }
        }
    });

    return { minDate, maxDate };
}
